// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3SVOd","boxTitle":"Qualiphy_boxTitle__2sO4P","box":"Qualiphy_box__aau5Q","toggleWrap":"Qualiphy_toggleWrap__1lXVo"};